import EmailIcon from '@mui/icons-material/Email';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Button } from '@efexteam/components';
import { errorIcon } from '../../../../assets';
import DetailView from '../components/DetailView';
import {
  CONTACT_METHODS,
  CONTACT_METHODS_LINK,
  CONTACT_METHODS_VALUES,
} from '../constants/catalogs';

interface ErrorProps {
  close: () => void;
  retry: () => void;
  isNotProcessed?: boolean;
}

const Error = ({ close, retry, isNotProcessed = false }: ErrorProps) => {
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={12} className="!mb-5">
        <div className="flex justify-center">
          <img
            className="max-w-[57px] max-h-[57px] mt-3"
            src={errorIcon}
            alt="retry-error"
          />
        </div>
        {!isNotProcessed ? (
          <>
            <Typography variant="h6" className="!my-4 !text-center">
              {t('paymentError')}
            </Typography>
            <Typography
              style={{ maxWidth: '350px', margin: 'auto' }}
              className="!my-5"
            >
              {t('paymentErrorMessage')}{' '}
              <a
                className="underline text-sky-600 hover:text-sky-800"
                href={CONTACT_METHODS_LINK[CONTACT_METHODS.EMAIL]}
              >
                {CONTACT_METHODS_VALUES[CONTACT_METHODS.EMAIL]}
              </a>{' '}
              {t('paymentErrorMessage1')}
            </Typography>
          </>
        ) : (
          <div className="flex flex-col justify-center items-center">
            <Typography variant="h6" className="!my-4 !text-center">
              {t('paymentNotProcessed')}
            </Typography>
            <Typography style={{ maxWidth: '350px' }} className="!my-5">
              {t('paymentNotProcessedMessage')}
            </Typography>
            <ul>
              <li>
                <a
                  style={{ textDecoration: 'none' }}
                  className="text-primary-text hover:text-alert-color"
                  href={CONTACT_METHODS_LINK[CONTACT_METHODS.SALES_EMAIL]}
                >
                  <EmailIcon sx={{ width: '20px', height: '20px' }} />{' '}
                  {CONTACT_METHODS_VALUES[CONTACT_METHODS.SALES_EMAIL]}
                </a>
              </li>
              <li className="my-3">
                <a
                  href={CONTACT_METHODS_LINK[CONTACT_METHODS.WHATSAPP]}
                  target="_blank"
                  rel="noreferrer"
                >
                  <WhatsAppIcon sx={{ width: '20px', height: '20px' }} />{' '}
                  {CONTACT_METHODS_VALUES[CONTACT_METHODS.WHATSAPP]}
                </a>
              </li>
            </ul>
          </div>
        )}
      </Grid>
      <DetailView isErrorDetail />
      <Grid
        item
        xs={12}
        className={`flex !flex-col md:!flex-row gap-4 ${
          !isNotProcessed ? 'justify-between' : 'justify-center'
        }`}
      >
        <Button
          appearance="secondary"
          size="large"
          className="mt-4"
          onClick={close}
        >
          {t('close')}
        </Button>
        {!isNotProcessed ? (
          <Button
            appearance="primary"
            size="large"
            className="mt-4"
            onClick={retry}
          >
            {t('errorRetry')}
          </Button>
        ) : null}
      </Grid>
    </Grid>
  );
};

export default Error;
